import React, { useState, useEffect } from "react";
import Main from "../components/layout/Main";
import { useParams, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { Table, Card, Button, Form, Modal } from "react-bootstrap";
import backArrow from "../assets/images/backArrow.png";
import avtarImg from "../assets/images/avtarImg.png";

function LeaderboardDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { request } = useRequest();
  const [leaderboard, setLeaderboard] = useState(null);
  const [playerScores, setPlayerScores] = useState([]);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [friends, setFriends] = useState([]);
  const [selectedFriends, setSelectedFriends] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeaderboard();
    fetchFriends();
  }, [id]);

  const fetchLeaderboard = () => {
    request({
      url: `/app/leaderboard/${id}`,
      method: "GET",
      onSuccess: (data) => {
        console.log("leaderboard", data);
        setLeaderboard(data.data);
        // Fetch player scores using the new endpoint
        fetchPlayerScores();
      },
      onError: (error) => {
        console.log("Error fetching leaderboard:", error);
        setLoading(false);
      }
    });
  };

  const fetchPlayerScores = () => {
    request({
      url: `/app/leaderboard/${id}/scores`,
      method: "GET",
      onSuccess: (response) => {
        console.log("Player scores data:", response);
        // The actual array is nested in response.data.data
        const scoresData = response.data?.data || response.data || [];
        setPlayerScores(Array.isArray(scoresData) ? scoresData : []);
        setLoading(false);
      },
      onError: (error) => {
        console.log("Error fetching player scores:", error);
        setPlayerScores([]);
        setLoading(false);
      }
    });
  };

  const fetchFriends = () => {
    request({
      url: "/app/friend/user-friend-list",
      method: "GET",
      onSuccess: (data) => {
        setFriends(data.data.data);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  const handleInvitePlayers = () => {
    request({
      url: `/app/leaderboard/${id}/invite`,
      method: "POST",
      data: { players: selectedFriends },
      onSuccess: (data) => {
        setShowInviteModal(false);
        setSelectedFriends([]);
        fetchLeaderboard(); // Refresh to show updated invited players
      },
      onError: (error) => {
        console.log("Error inviting players:", error);
      }
    });
  };

  const handleScoreClick = (gameId) => {
    if (gameId) {
      navigate(`/allScoreData/${gameId}`);
    } else {
      alert("Score card not available");
    }
  };

  const PlayerScoreCard = ({ playerData }) => {
    const { user: player } = playerData;
    
    return (
      <div className="col-md-6 col-lg-4 mb-3">
        <div className="card player-score-card h-100">
          <div className="card-body d-flex flex-column align-items-center text-center">
            {/* Player Avatar */}
            <div className="player-avatar mb-3">
              <img 
                className="rounded-circle"
                style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                src={
                  player?.profilePic
                    ? `https://pwabucket1.s3.amazonaws.com/${player.profilePic}`
                    : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                        player?.name || 'Unknown'
                      )}&size=256`
                } 
                alt="Avatar" 
              />
            </div>
            
            {/* Player Name */}
            <h6 className="card-title">{player?.name || 'Unknown Player'}</h6>
            
            {/* Player Details */}
            <div className="player-details mb-3">
              <small className="text-muted">
                Handicap: {playerData?.handicap || player?.handicap || 'N/A'}
              </small>
            </div>
            
            {/* Score Circle - Clickable */}
            <div 
              className="score-circle-container cursor-pointer"
              onClick={() => handleScoreClick(playerData.gameId)}
              style={{ cursor: 'pointer' }}
            >
              <div className="score-post d-flex flex-column align-items-center">
                <div 
                  className="post-info-ic bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: '60px', height: '60px', fontSize: '18px', fontWeight: 'bold' }}
                >
                  {playerData.totalScore !== null && playerData.totalScore !== undefined ? playerData.totalScore : 0}
                </div>
                <span className="mt-2 text-primary">Score</span>
              </div>
            </div>
            
            {/* Additional Score Info */}
            <div className="score-details mt-2">
              <div className="row text-center">
                <div className="col-6">
                  <small className="text-muted">Putts</small>
                  <div>{playerData.putts || 0}</div>
                </div>
                <div className="col-6">
                  <small className="text-muted">Penalties</small>
                  <div>{playerData.penalties || 0}</div>
                </div>
              </div>
              {playerData.averageTotalScore && (
                <div className="row text-center mt-2">
                  <div className="col-12">
                    <small className="text-muted">Avg Score: {playerData.averageTotalScore.toFixed(1)}</small>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <Main>
        <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </Main>
    );
  }

  if (!leaderboard) {
    return (
      <Main>
        <div className="alert alert-danger">Leaderboard not found or access denied.</div>
      </Main>
    );
  }

  // Sort players by total score for leaderboard ranking
  const sortedPlayerScores = [...playerScores].sort((a, b) => {
    const scoreA = a.totalScore || 0;
    const scoreB = b.totalScore || 0;
    return scoreA - scoreB;
  });

  return (
    <Main>
      <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
        <div className="row g-3">
          <div className="col-lg-12">
            <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
              <button onClick={() => navigate("/current-leaderboard")} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
                <img className="h-100" src={backArrow} alt="Back"/>
              </button> 
              <div className="txt">{leaderboard.name}</div>
            </div>
          </div>

          <div className="col-md-6">
            <Card>
              <Card.Header>
                <h5>Leaderboard Details</h5>
              </Card.Header>
              <Card.Body>
                <p><strong>Course:</strong> {leaderboard.course?.name || "Unknown"}</p>
                <p><strong>Tee:</strong> {leaderboard.courseTee?.name || "Unknown"}</p>
                <p><strong>Holes:</strong> {leaderboard.holes}</p>
                <p><strong>Type:</strong> {leaderboard.type}</p>
                <p><strong>Game Format:</strong> {leaderboard.gameFormat}</p>
                <p><strong>Scoring:</strong> {leaderboard.scoreType}</p>
                <p><strong>Created by:</strong> {leaderboard.user?.name}</p>
                <p><strong>Players:</strong> {leaderboard.playerCount || leaderboard.players?.length || 0} joined</p>
                
                {leaderboard.user?._id === JSON.parse(localStorage.getItem("user"))?._id && (
                  <Button variant="primary" onClick={() => setShowInviteModal(true)}>
                    Invite Players
                  </Button>
                )}
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-6">
            <Card>
              <Card.Header>
                <h5>Leaderboard Summary</h5>
              </Card.Header>
              <Card.Body>
                <Table striped size="sm">
                  <thead>
                    <tr>
                      <th>Pos</th>
                      <th>Player</th>
                      <th>Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedPlayerScores
                      .slice(0, 5)
                      .map((playerData, index) => (
                        <tr key={playerData._id || playerData.user?._id}>
                          <td>{index + 1}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              <img 
                                className="rounded-circle me-2"
                                style={{ width: '30px', height: '30px', objectFit: 'cover' }}
                                src={
                                  playerData.user?.profilePic
                                    ? `https://pwabucket1.s3.amazonaws.com/${playerData.user.profilePic}`
                                    : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                        playerData.user?.name || 'Unknown'
                                      )}&size=256`
                                } 
                                alt="Avatar" 
                              />
                              {playerData.user?.name || 'Unknown'}
                            </div>
                          </td>
                          <td>{playerData.totalScore || 0}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </div>

          {/* Players and Scores Section */}
          <div className="col-12">
            <Card>
              <Card.Header>
                <h5>Player Scores</h5>
                <small className="text-muted">Click on a player's score to view their scorecard</small>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  {playerScores && playerScores.length > 0 ? (
                    playerScores.map(playerData => (
                      <PlayerScoreCard 
                        key={playerData._id || playerData.user?._id} 
                        playerData={playerData}
                      />
                    ))
                  ) : (
                    <div className="col-12">
                      <div className="alert alert-info text-center">
                        No players have joined this leaderboard yet or no scores recorded.
                      </div>
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
          </div>

          {/* Traditional Leaderboard Table */}
          <div className="col-12">
            <Card>
              <Card.Header>
                <h5>Detailed Leaderboard</h5>
              </Card.Header>
              <Card.Body>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Position</th>
                      <th>Player</th>
                      <th>Avatar</th>
                      <th>Total Score</th>
                      <th>Handicap Score</th>
                      <th>Putts</th>
                      <th>Penalties</th>
                      <th>Avg Score</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedPlayerScores.length > 0 ? (
                      sortedPlayerScores.map((playerData, index) => (
                        <tr key={playerData._id || playerData.user?._id}>
                          <td>
                            <span className="badge bg-primary">{index + 1}</span>
                          </td>
                          <td>
                            <strong>{playerData.user?.name || 'Unknown Player'}</strong>
                          </td>
                          <td>
                            <img 
                              className="rounded-circle"
                              style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                              src={
                                playerData.user?.profilePic
                                  ? `https://pwabucket1.s3.amazonaws.com/${playerData.user.profilePic}`
                                  : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                                      playerData.user?.name || 'Unknown'
                                    )}&size=256`
                              } 
                              alt="Avatar" 
                            />
                          </td>
                          <td>
                            <span 
                              className="cursor-pointer text-primary fw-bold"
                              onClick={() => handleScoreClick(playerData.gameId)}
                              style={{ cursor: 'pointer' }}
                            >
                              {playerData.totalScore || 0}
                            </span>
                          </td>
                          <td>{playerData.handicap || 0}</td>
                          <td>{playerData.putts || 0}</td>
                          <td>{playerData.penalties || 0}</td>
                          <td>{playerData.averageTotalScore ? playerData.averageTotalScore.toFixed(1) : 'N/A'}</td>
                          <td>
                            <span className={`badge ${playerData.isFinished ? 'bg-success' : 'bg-warning'}`}>
                              {playerData.isFinished ? 'Completed' : 'In Progress'}
                            </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">No scores recorded yet</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </div>
        </div>
      </section>

      {/* Invite Modal */}
      <Modal show={showInviteModal} onHide={() => setShowInviteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Invite Players</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {friends.map(friend => (
              <Form.Check
                key={friend._id}
                type="checkbox"
                id={`friend-${friend._id}`}
                label={
                  <div className="d-flex align-items-center">
                    <img 
                      className="rounded-circle me-2"
                      style={{ width: '30px', height: '30px', objectFit: 'cover' }}
                      src={
                        friend?.profilePic
                          ? `https://pwabucket1.s3.amazonaws.com/${friend.profilePic}`
                          : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                              friend?.name || 'Unknown'
                            )}&size=256`
                      } 
                      alt="Avatar" 
                    />
                    {friend.name}
                  </div>
                }
                checked={selectedFriends.includes(friend._id)}
                onChange={() => {
                  if (selectedFriends.includes(friend._id)) {
                    setSelectedFriends(selectedFriends.filter(id => id !== friend._id));
                  } else {
                    setSelectedFriends([...selectedFriends, friend._id]);
                  }
                }}
              />
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowInviteModal(false)}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={handleInvitePlayers}
            disabled={selectedFriends.length === 0}
          >
            Send Invitations ({selectedFriends.length})
          </Button>
        </Modal.Footer>
      </Modal>

      <style jsx>{`
        .player-score-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
        }
        
        .score-circle-container:hover .post-info-ic {
          transform: scale(1.1);
          transition: all 0.3s ease;
        }
        
        .cursor-pointer {
          cursor: pointer;
        }
        
        .cursor-pointer:hover {
          text-decoration: underline;
        }

        .post-info-ic {
          transition: transform 0.3s ease;
        }

        .score-post {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      `}</style>
    </Main>
  );
}

export default LeaderboardDetail;


// import React, { useState, useEffect } from "react";
// import Main from "../components/layout/Main";
// import { useParams, useNavigate } from "react-router-dom";
// import useRequest from "../hooks/useRequest";
// import { Table, Card, Button, Form, Modal } from "react-bootstrap";
// import backArrow from "../assets/images/backArrow.png";
// import avtarImg from "../assets/images/avtarImg.png";

// function LeaderboardDetail() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const { request } = useRequest();
//   const [leaderboard, setLeaderboard] = useState(null);
//   const [playerScores, setPlayerScores] = useState([]);
//   const [showInviteModal, setShowInviteModal] = useState(false);
//   const [friends, setFriends] = useState([]);
//   const [selectedFriends, setSelectedFriends] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchLeaderboard();
//     fetchFriends();
//   }, [id]);

//   const fetchLeaderboard = () => {
//     request({
//       url: `/app/leaderboard/${id}`,
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("leaderboard", data)
//         setLeaderboard(data.data);
//         fetchPlayerScores(data.data.gameId);
//       },
//       onError: (error) => {
//         console.log("Error fetching leaderboard:", error);
//         setLoading(false);
//       }
//     });
//   };

//   const fetchPlayerScores = (gameId) => {
//     if (!gameId) {
//       setLoading(false);
//       return;
//     }

//     // Fetch game details to get player scores
//     request({
//       url: `/app/game/${gameId}`,
//       method: "GET",
//       onSuccess: (gameData) => {
//         console.log("Game data:", gameData);
        
//         // Get game records for each player
//         const gameRecords = gameData.data.gameDetailsId || [];
//         const scoresPromises = gameRecords.map(recordId => 
//           new Promise((resolve) => {
//             request({
//               url: `/app/game-records/${recordId}`,
//               method: "GET",
//               onSuccess: (recordData) => resolve(recordData.data),
//               onError: () => resolve(null)
//             });
//           })
//         );

//         Promise.all(scoresPromises).then(scores => {
//           const validScores = scores.filter(score => score !== null);
//           console.log("Player scores:", validScores);
//           setPlayerScores(validScores);
//           setLoading(false);
//         });
//       },
//       onError: (error) => {
//         console.log("Error fetching game data:", error);
//         setLoading(false);
//       }
//     });
//   };

//   const fetchFriends = () => {
//     request({
//       url: "/app/friend/user-friend-list",
//       method: "GET",
//       onSuccess: (data) => {
//         setFriends(data.data.data);
//       },
//       onError: (error) => {
//         console.log(error);
//       },
//     });
//   };

//   const handleInvitePlayers = () => {
//     request({
//       url: `/app/leaderboard/${id}/invite`,
//       method: "POST",
//       data: { players: selectedFriends },
//       onSuccess: (data) => {
//         setShowInviteModal(false);
//         setSelectedFriends([]);
//         fetchLeaderboard(); // Refresh to show updated invited players
//       },
//       onError: (error) => {
//         console.log("Error inviting players:", error);
//       }
//     });
//   };

//   const handleScoreClick = (gameId) => {
//     if (gameId) {
//       navigate(`/allScoreData/${gameId}`);
//     } else {
//       alert("Score card not available");
//     }
//   };

//   const PlayerScoreCard = ({ player, score }) => (
//     <div className="col-md-6 col-lg-4 mb-3">
//       <div className="card player-score-card h-100">
//         <div className="card-body d-flex flex-column align-items-center text-center">
//           {/* Player Avatar */}
//           <div className="player-avatar mb-3">
//             <img 
//               className="rounded-circle"
//               style={{ width: '80px', height: '80px', objectFit: 'cover' }}
//               src={
//                 player?.profilePic
//                   ? `https://pwabucket1.s3.amazonaws.com/${player.profilePic}`
//                   : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                       player?.name || 'Unknown'
//                     )}&size=256`
//               } 
//               alt="Avatar" 
//             />
//           </div>
          
//           {/* Player Name */}
//           <h6 className="card-title">{player?.name || 'Unknown Player'}</h6>
          
//           {/* Player Details */}
//           <div className="player-details mb-3">
//             <small className="text-muted">
//               Handicap: {player?.handicap || 'N/A'}
//             </small>
//           </div>
          
//           {/* Score Circle - Clickable */}
//           {score && (
//             <div 
//               className="score-circle-container cursor-pointer"
//               onClick={() => handleScoreClick(score.gameId)}
//               style={{ cursor: 'pointer' }}
//             >
//               <div className="score-post d-flex flex-column align-items-center">
//                 <div 
//                   className="post-info-ic bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
//                   style={{ width: '60px', height: '60px', fontSize: '18px', fontWeight: 'bold' }}
//                 >
//                   {score.totalScore !== null ? score.totalScore : 0}
//                 </div>
//                 <span className="mt-2 text-primary">Score</span>
//               </div>
//             </div>
//           )}
          
//           {/* Additional Score Info */}
//           {score && (
//             <div className="score-details mt-2">
//               <div className="row text-center">
//                 <div className="col-6">
//                   <small className="text-muted">Putts</small>
//                   <div>{score.putts || 0}</div>
//                 </div>
//                 <div className="col-6">
//                   <small className="text-muted">Penalties</small>
//                   <div>{score.penalties || 0}</div>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );

//   if (loading) {
//     return (
//       <Main>
//         <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       </Main>
//     );
//   }

//   if (!leaderboard) {
//     return (
//       <Main>
//         <div className="alert alert-danger">Leaderboard not found or access denied.</div>
//       </Main>
//     );
//   }

//   return (
//     <Main>
//       <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
//         <div className="row g-3">
//           <div className="col-lg-12">
//             <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
//               <button onClick={() => navigate("/current-leaderboard")} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
//                 <img className="h-100" src={backArrow} alt="Back"/>
//               </button> 
//               <div className="txt">{leaderboard.name}</div>
//             </div>
//           </div>

//           <div className="col-md-6">
//             <Card>
//               <Card.Header>
//                 <h5>Leaderboard Details</h5>
//               </Card.Header>
//               <Card.Body>
//                 <p><strong>Course:</strong> {leaderboard.course?.name || "Unknown"}</p>
//                 <p><strong>Tee:</strong> {leaderboard.courseTee?.name || "Unknown"}</p>
//                 <p><strong>Holes:</strong> {leaderboard.holes}</p>
//                 <p><strong>Type:</strong> {leaderboard.type}</p>
//                 <p><strong>Game Format:</strong> {leaderboard.gameFormat}</p>
//                 <p><strong>Scoring:</strong> {leaderboard.scoreType}</p>
//                 <p><strong>Created by:</strong> {leaderboard.user?.name}</p>
//                 <p><strong>Players:</strong> {leaderboard.playerCount} joined</p>
                
//                 {leaderboard.user?._id === JSON.parse(localStorage.getItem("user"))?._id && (
//                   <Button variant="primary" onClick={() => setShowInviteModal(true)}>
//                     Invite Players
//                   </Button>
//                 )}
//               </Card.Body>
//             </Card>
//           </div>

//           <div className="col-md-6">
//             <Card>
//               <Card.Header>
//                 <h5>Leaderboard Summary</h5>
//               </Card.Header>
//               <Card.Body>
//                 <Table striped size="sm">
//                   <thead>
//                     <tr>
//                       <th>Pos</th>
//                       <th>Player</th>
//                       <th>Score</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {playerScores
//                       .sort((a, b) => (a.totalScore || 0) - (b.totalScore || 0))
//                       .slice(0, 5)
//                       .map((score, index) => (
//                         <tr key={score._id}>
//                           <td>{index + 1}</td>
//                           <td>{score.user?.name || 'Unknown'}</td>
//                           <td>{score.totalScore || 0}</td>
//                         </tr>
//                       ))}
//                   </tbody>
//                 </Table>
//               </Card.Body>
//             </Card>
//           </div>

//           {/* Players and Scores Section */}
//           <div className="col-12">
//             <Card>
//               <Card.Header>
//                 <h5>Player Scores</h5>
//                 <small className="text-muted">Click on a player's score to view their scorecard</small>
//               </Card.Header>
//               <Card.Body>
//                 <div className="row">
//                   {leaderboard.players && leaderboard.players.length > 0 ? (
//                     leaderboard.players.map(player => {
//                       const playerScore = playerScores.find(score => 
//                         score.user?._id === player._id
//                       );
                      
//                       return (
//                         <PlayerScoreCard 
//                           key={player._id} 
//                           player={player} 
//                           score={playerScore}
//                         />
//                       );
//                     })
//                   ) : (
//                     <div className="col-12">
//                       <div className="alert alert-info text-center">
//                         No players have joined this leaderboard yet.
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </Card.Body>
//             </Card>
//           </div>

//           {/* Traditional Leaderboard Table */}
//           <div className="col-12">
//             <Card>
//               <Card.Header>
//                 <h5>Detailed Leaderboard</h5>
//               </Card.Header>
//               <Card.Body>
//                 <Table striped bordered hover responsive>
//                   <thead>
//                     <tr>
//                       <th>Position</th>
//                       <th>Player</th>
//                       <th>Avatar</th>
//                       <th>Total Score</th>
//                       <th>Handicap Score</th>
//                       <th>Putts</th>
//                       <th>Penalties</th>
//                       <th>Status</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {playerScores.length > 0 ? (
//                       playerScores
//                         .sort((a, b) => (a.totalScore || 0) - (b.totalScore || 0))
//                         .map((score, index) => (
//                           <tr key={score._id}>
//                             <td>
//                               <span className="badge bg-primary">{index + 1}</span>
//                             </td>
//                             <td>
//                               <strong>{score.user?.name || 'Unknown Player'}</strong>
//                             </td>
//                             <td>
//                               <img 
//                                 className="rounded-circle"
//                                 style={{ width: '40px', height: '40px', objectFit: 'cover' }}
//                                 src={
//                                   score.user?.profilePic
//                                     ? `https://pwabucket1.s3.amazonaws.com/${score.user.profilePic}`
//                                     : `https://ui-avatars.com/api/?name=${encodeURIComponent(
//                                         score.user?.name || 'Unknown'
//                                       )}&size=256`
//                                 } 
//                                 alt="Avatar" 
//                               />
//                             </td>
//                             <td>
//                               <span 
//                                 className="cursor-pointer text-primary fw-bold"
//                                 onClick={() => handleScoreClick(score.gameId)}
//                                 style={{ cursor: 'pointer' }}
//                               >
//                                 {score.totalScore || 0}
//                               </span>
//                             </td>
//                             <td>{score.handicapScore || 0}</td>
//                             <td>{score.putts || 0}</td>
//                             <td>{score.penalties || 0}</td>
//                             <td>
//                               <span className={`badge ${score.isFinished ? 'bg-success' : 'bg-warning'}`}>
//                                 {score.isFinished ? 'Completed' : 'In Progress'}
//                               </span>
//                             </td>
//                           </tr>
//                         ))
//                     ) : (
//                       <tr>
//                         <td colSpan="8" className="text-center">No scores recorded yet</td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </Card.Body>
//             </Card>
//           </div>
//         </div>
//       </section>

//       {/* Invite Modal */}
//       <Modal show={showInviteModal} onHide={() => setShowInviteModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Invite Players</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             {friends.map(friend => (
//               <Form.Check
//                 key={friend._id}
//                 type="checkbox"
//                 id={`friend-${friend._id}`}
//                 label={friend.name}
//                 checked={selectedFriends.includes(friend._id)}
//                 onChange={() => {
//                   if (selectedFriends.includes(friend._id)) {
//                     setSelectedFriends(selectedFriends.filter(id => id !== friend._id));
//                   } else {
//                     setSelectedFriends([...selectedFriends, friend._id]);
//                   }
//                 }}
//               />
//             ))}
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowInviteModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleInvitePlayers}>
//             Send Invitations
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <style jsx>{`
//         .player-score-card:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 4px 8px rgba(0,0,0,0.1);
//           transition: all 0.3s ease;
//         }
        
//         .score-circle-container:hover .post-info-ic {
//           transform: scale(1.1);
//           transition: all 0.3s ease;
//         }
        
//         .cursor-pointer {
//           cursor: pointer;
//         }
        
//         .cursor-pointer:hover {
//           text-decoration: underline;
//         }
//       `}</style>
//     </Main>
//   );
// }

// export default LeaderboardDetail;








// import React, { useState, useEffect } from "react";
// import Main from "../components/layout/Main";
// import { useParams, useNavigate } from "react-router-dom";
// import useRequest from "../hooks/useRequest";
// import { Table, Card, Button, Form, Modal } from "react-bootstrap";
// import backArrow from "../assets/images/backArrow.png";

// function LeaderboardDetail() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const { request } = useRequest();
//   const [leaderboard, setLeaderboard] = useState(null);
//   const [scores, setScores] = useState([]);
//   const [showInviteModal, setShowInviteModal] = useState(false);
//   const [friends, setFriends] = useState([]);
//   const [selectedFriends, setSelectedFriends] = useState([]);

//   useEffect(() => {
//     fetchLeaderboard();
//     fetchFriends();
//   }, [id]);

//   const fetchLeaderboard = () => {
//     request({
//       url: `/app/leaderboard/${id}`,
//       method: "GET",
//       onSuccess: (data) => {
//         console.log("leaderboard", data)
//         setLeaderboard(data.data);
//         // Here you would also fetch the scores for this leaderboard
//       },
//       onError: (error) => {
//         console.log("Error fetching leaderboard:", error);
//       }
//     });
//   };

//   const fetchFriends = () => {
//     request({
//       url: "/app/friend/user-friend-list",
//       method: "GET",
//       onSuccess: (data) => {
//         setFriends(data.data.data);
//       },
//       onError: (error) => {
//         console.log(error);
//       },
//     });
//   };

//   const handleInvitePlayers = () => {
//     request({
//       url: `/app/leaderboard/${id}/invite`,
//       method: "POST",
//       data: { players: selectedFriends },
//       onSuccess: (data) => {
//         setShowInviteModal(false);
//         setSelectedFriends([]);
//         fetchLeaderboard(); // Refresh to show updated invited players
//       },
//       onError: (error) => {
//         console.log("Error inviting players:", error);
//       }
//     });
//   };

//   if (!leaderboard) {
//     return <Main>Loading...</Main>;
//   }

//   return (
//     <Main>
//       <section className="home-wrap px-lg-4 px-3 pb-lg-4 pb-3 container-fluid">
//         <div className="row g-3">
//           <div className="col-lg-12">
//             <div className="pageHeadign d-flex align-items-center gap-3 mb-3">
//               <button onClick={() => navigate("/current-leaderboard")} className="btn backBtn bg-transparent border-0 shadow-none p-0 d-flex">
//                 <img className="h-100" src={backArrow} alt="Back"/>
//               </button> 
//               <div className="txt">{leaderboard.name}</div>
//             </div>
//           </div>

//           <div className="col-md-6">
//             <Card>
//               <Card.Header>
//                 <h5>Leaderboard Details</h5>
//               </Card.Header>
//               <Card.Body>
//                 <p><strong>Course:</strong> {leaderboard.course?.name || "Unknown"}</p>
//                 <p><strong>Tee:</strong> {leaderboard.courseTee?.name || "Unknown"}</p>
//                 <p><strong>Holes:</strong> {leaderboard.holes}</p>
//                 <p><strong>Type:</strong> {leaderboard.type}</p>
//                 <p><strong>Scoring:</strong> {leaderboard.scoreType}</p>
//                 <p><strong>Created by:</strong> {leaderboard.user?.name}</p>
//                 <p><strong>Players:</strong> {leaderboard.playerCount} joined</p>
                
//                 {leaderboard.user?._id === JSON.parse(localStorage.getItem("user"))?._id && (
//                   <Button variant="primary" onClick={() => setShowInviteModal(true)}>
//                     Invite Players
//                   </Button>
//                 )}
//               </Card.Body>
//             </Card>
//           </div>

//           <div className="col-md-6">
//             <Card>
//               <Card.Header>
//                 <h5>Players</h5>
//               </Card.Header>
//               <Card.Body>
//                 <ul className="list-group">
//                   {leaderboard.players.map(player => (
//                     <li key={player._id} className="list-group-item d-flex justify-content-between align-items-center">
//                       {player.name}
//                       <span className="badge bg-primary rounded-pill">Handicap: {player.handicap || "N/A"}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </Card.Body>
//             </Card>
//           </div>

//           <div className="col-12">
//             <Card>
//               <Card.Header>
//                 <h5>Scores</h5>
//               </Card.Header>
//               <Card.Body>
//                 <Table striped bordered hover>
//                   <thead>
//                     <tr>
//                       <th>Position</th>
//                       <th>Player</th>
//                       <th>Total Score</th>
//                       <th>Thru</th>
//                       <th>Today</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {scores.length > 0 ? (
//                       scores.map((score, index) => (
//                         <tr key={score._id}>
//                           <td>{index + 1}</td>
//                           <td>{score.player?.name}</td>
//                           <td>{score.totalScore}</td>
//                           <td>{score.holesCompleted}</td>
//                           <td>{score.todayScore}</td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="5" className="text-center">No scores recorded yet</td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </Card.Body>
//             </Card>
//           </div>
//         </div>
//       </section>

//       {/* Invite Modal */}
//       <Modal show={showInviteModal} onHide={() => setShowInviteModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Invite Players</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             {friends.map(friend => (
//               <Form.Check
//                 key={friend._id}
//                 type="checkbox"
//                 id={`friend-${friend._id}`}
//                 label={friend.name}
//                 checked={selectedFriends.includes(friend._id)}
//                 onChange={() => {
//                   if (selectedFriends.includes(friend._id)) {
//                     setSelectedFriends(selectedFriends.filter(id => id !== friend._id));
//                   } else {
//                     setSelectedFriends([...selectedFriends, friend._id]);
//                   }
//                 }}
//               />
//             ))}
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowInviteModal(false)}>
//             Cancel
//           </Button>
//           <Button variant="primary" onClick={handleInvitePlayers}>
//             Send Invitations
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Main>
//   );
// }

// export default LeaderboardDetail;